// import React, { useEffect, useState } from "react";
// import aiFilmmakingInsights from "./aiFilmmakingInsights";
// import "./Film.css";

// const AiFilmmakingInsightsDisplay = () => {
//     const [currentCategory, setCurrentCategory] = useState(null);
//     const [currentPoint, setCurrentPoint] = useState(null);
//     const [fade, setFade] = useState(true);

//     useEffect(() => {
//         const getRandomInsight = () => {
//             const category =
//                 aiFilmmakingInsights[
//                 Math.floor(Math.random() * aiFilmmakingInsights.length)
//                 ];

//             const point =
//                 category.points[
//                 Math.floor(Math.random() * category.points.length)
//                 ];

//             return { category, point };
//         };

//         const updateInsight = () => {
//             const { category, point } = getRandomInsight();

//             setCurrentCategory(category);
//             setCurrentPoint(point);
//         };

//         updateInsight();

//         let changeTimeout;

//         const interval = setInterval(() => {
//             setFade(false);

//             changeTimeout = setTimeout(() => {
//                 updateInsight();
//                 setFade(true);
//             }, 450);
//         }, 8000);

//         return () => {
//             clearInterval(interval);
//             clearTimeout(changeTimeout);
//         };
//     }, []);

//     if (!currentCategory || !currentPoint) {
//         return null;
//     }

//     return (
//         <div className="va-recommendation-insight">
//             <div className="va-recommendation-insight-header">
//                 <div>
//                     <div className="va-recommendation-insight-category">
//                         {currentCategory.category}
//                     </div>
//                 </div>
//             </div>
//             <div
//                 className={`va-recommendation-insight-body ${fade ? "is-visible" : "is-hidden"
//                     }`}
//             >
//                 <div className="va-recommendation-insight-title">
//                     {currentPoint.title}
//                 </div>

//                 <p className="va-recommendation-insight-text">
//                     {currentPoint.text}
//                 </p>
//             </div>
//         </div>
//     );
// };

// export default AiFilmmakingInsightsDisplay;




import React, { useEffect, useState } from "react";
import aiFilmmakingInsights from "./aiFilmmakingInsights";
import "./Film.css";

const AiFilmmakingInsightsDisplay = () => {
    const [currentCategory, setCurrentCategory] = useState(null);
    const [currentPoint, setCurrentPoint] = useState(null);
    const [fade, setFade] = useState(true);

    useEffect(() => {
        const getRandomInsight = () => {
            if (!aiFilmmakingInsights?.length) {
                return {
                    category: null,
                    point: null,
                };
            }

            const category =
                aiFilmmakingInsights[
                Math.floor(Math.random() * aiFilmmakingInsights.length)
                ];

            if (!category?.points?.length) {
                return {
                    category,
                    point: null,
                };
            }

            const point =
                category.points[
                Math.floor(Math.random() * category.points.length)
                ];

            return {
                category,
                point,
            };
        };

        const updateInsight = () => {
            const { category, point } = getRandomInsight();

            if (!category || !point) {
                return;
            }

            setCurrentCategory(category);
            setCurrentPoint(point);
        };

        // Initial insight
        updateInsight();

        let changeTimeout;

        const interval = setInterval(() => {
            setFade(false);

            changeTimeout = setTimeout(() => {
                updateInsight();
                setFade(true);
            }, 450);
        }, 8000);

        return () => {
            clearInterval(interval);
            clearTimeout(changeTimeout);
        };
    }, []);

    if (!currentCategory || !currentPoint) {
        return null;
    }

    return (
        <div className="va-recommendation-insight">
            {/* Decorative glow */}
            <div className="va-recommendation-insight-glow" />

            {/* Top shine */}
            <div className="va-recommendation-insight-shine" />

            <div
                className={`va-recommendation-insight-content ${fade ? "is-visible" : "is-hidden"
                    }`}
            >
                {/* Header */}
                <div className="va-recommendation-insight-header">
                    {/* <div className="va-recommendation-insight-icon">
                        <span>✦</span>
                    </div> */}

                    <div className="va-recommendation-insight-heading">
                        {/* <div className="va-recommendation-insight-label">
                            AI FILMMAKING INSIGHT
                        </div> */}

                        {/* <div className="va-recommendation-insight-category">
                            {currentCategory.category}
                        </div> */}
                    </div>
                </div>

                {/* Main content */}
                <div
                    style={{
                        textAlign: "left"
                    }}
                    className="va-recommendation-insight-body">
                    <div

                        style={{
                            color: "GrayText"
                        }}
                        className="va-recommendation-insight-category mb-2">
                        {currentCategory.category}
                    </div>
                    <div
                        style={{
                            color: "#FFA423"
                        }}
                        className="va-recommendation-insight-title">
                        {currentPoint.title}
                    </div>

                    <p className="va-recommendation-insight-text">
                        {currentPoint.text}
                    </p>
                </div>

                {/* Footer */}
                <div className="va-recommendation-insight-footer">
                    <div className="va-recommendation-insight-tip">
                        <span className="va-recommendation-insight-tip-dot" />
                        {/* <span>Creative tip</span> */}
                    </div>

                    <div
                        className="va-recommendation-insight-progress"
                        aria-label="Insight rotation"
                    >
                        <span className="active" />
                        <span />
                        <span />
                        <span />
                        <span />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AiFilmmakingInsightsDisplay;